'use client';

import { Loading as LoadingComponent } from '@carbon/react';

export default function Loading() {
  // You can add any UI inside Loading, including a Skeleton.
  return <LoadingComponent withOverlay />;
}
